exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-filter-menu .mp-filter-menu-header {\n  border-bottom: 1px solid #e9e9e9;\n  display: none;\n}\n.mp-filter-menu .mp-filter-menu-header.is-visible {\n  display: flex;\n}\n.mp-filter-menu mp-select.mp-filter-menu-cohort-options {\n  flex: 1;\n  margin: 8px;\n}\n", ""]);

// exports
